import globalReducer from './global.js'
export { globalReducer }
